import { getResolvedRef } from "../helpers/get-resolved-ref.js";
const requestExampleMutators = (document) => {
  const addRequestExample = ({
    path,
    method,
    slug,
    request
  }) => {
    if (!document || !document.paths) {
      return false;
    }
    if (!document.paths[path]) {
      document.paths[path] = {};
    }
    if (!document.paths[path][method]) {
      document.paths[path][method] = {};
    }
    const operation = getResolvedRef(document.paths[path][method]);
    if (!operation["x-scalar-client-config-request-example"]) {
      operation["x-scalar-client-config-request-example"] = {};
    }
    if (operation["x-scalar-client-config-request-example"][slug]) {
      console.warn(`Request example with slug "${slug}" already exists for ${method.toUpperCase()} ${path}.`);
      return false;
    }
    operation["x-scalar-client-config-request-example"][slug] = request;
    return true;
  };
  const deleteRequestExample = ({ path, method, slug }) => {
    if (!document) {
      return false;
    }
    const pathObject = document?.paths?.[path];
    if (!pathObject) {
      return false;
    }
    const operation = getResolvedRef(pathObject[method]);
    if (!operation) {
      return false;
    }
    if (!operation["x-scalar-client-config-request-example"]) {
      return false;
    }
    delete operation["x-scalar-client-config-request-example"][slug];
    return true;
  };
  return {
    addRequestExample,
    deleteRequestExample
  };
};
export {
  requestExampleMutators
};
//# sourceMappingURL=request-example.js.map
